import { BodySvg } from 'components/Body/BodySvg'
import { LeberDiagramm } from 'components/LeberDiagramm'
import { LocaleContext } from 'components/MainComponent/MainComponent'
import {
  CSSProperties,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'
const damagecolor = '#D3343F'
export const BodyComponent = ({
  currentView,
  colorMode,
}: {
  currentView: string
  colorMode: 'dark' | 'light' | undefined
}) => {
  const { width } = useWindowSize()
  const [height, setHeight] = useState(0)
  const [view, setView] = useState<string>('first')
  const bgcolor = colorMode === 'dark' ? '#121212' : '#fff'
  const bodycolor = colorMode === 'dark' ? '#282828' : '#E9E9E9'
  const organcolor = colorMode === 'dark' ? '#3f3f3f' : '#D4D4D4'
  const inimportantcolor = colorMode === 'dark' ? '#3f3f3f' : organcolor
  const TEXT = useContext(LocaleContext)

  const arteriescolor = '#9E272F'
  const veincolor = '#D3343F'
  const alkoholcolor = colorMode === 'dark' ? '#FFE462' : '#2CA29F'

  useEffect(() => {
    setHeight(window.innerHeight)
  }, [width, height])

  useEffect(() => {
    if (currentView) setView(currentView)
  }, [currentView])

  const isMobile = width < 712

  const Views: { [key: string]: CSSProperties } = {
    first: {
      height: height * (isMobile ? 0.75 : 0.75),
      marginTop: isMobile ? '10px' : height * 0.05 + 'px',
      left: (isMobile ? 32 : 45) + '%',
    },
    second: {
      height: height * (isMobile ? 0.75 : 0.75),
      marginTop: isMobile ? '10px' : height * 0.05 + 'px',
      left: (isMobile ? 32 : 45) + '%',
    },
    third: {
      height: height * (isMobile ? 0.75 : 0.75),
      marginTop: isMobile ? '10px' : height * 0.05 + 'px',
      left: (isMobile ? 32 : 45) + '%',
    },
    fourth: {
      height: height * (isMobile ? 0.75 : 0.75),
      marginTop: isMobile ? '10px' : height * 0.05 + 'px',
      left: (isMobile ? 32 : 45) + '%',
    },
    fifth: {
      height: height * (isMobile ? 0.75 : 0.75),
      marginTop: isMobile ? '10px' : height * 0.05 + 'px',
      left: (isMobile ? 32 : 45) + '%',
    },
    sixt: {
      height: height * (isMobile ? 2 : 2),
      marginTop: isMobile ? '220px' : height * 0.05 + 'px',
      left: (isMobile ? 5 : 36) + '%',
    },
    seventh: {
      height: height * (isMobile ? 1.6 : 2),
      marginTop: height * 0.05 + 'px',
      left: (isMobile ? 15 : 35) + '%',
    },
    eight: {
      height: height * (isMobile ? 9 : 8),
      marginTop: isMobile ? -height * 2.5 : -height * 2.2,
      left: (isMobile ? -105 : -13) + '%',
    },
    nine: {
      height: height * (isMobile ? 0.65 : 0.75),
      marginTop: isMobile ? '10px' : height * 0.05 + 'px',
      left: (isMobile ? 36 : 45) + '%',
    },
    ten: {
      height: height * (isMobile ? 0.65 : 0.75),
      marginTop: isMobile ? '10px' : height * 0.05 + 'px',
      left: (isMobile ? 36 : 45) + '%',
    },
  }

  const Layers: { [key: string]: any } = {
    first: {
      organs: { opacity: 1 },
      speiseroehre: { opacity: 1 },
      magen: { opacity: 1 },
      duenndarm: { opacity: 1 },
      leber: { opacity: 1 },
      bauchspeicheldruese: { opacity: 1 },
      gallenblase: { opacity: 1 },
      dickdarm: { opacity: 1 },
      bodycontours: { stroke: bgcolor, strokeWidth: 1 },
      bodybg: { fill: bodycolor },
    },
    second: {
      organs: { opacity: 1 },
      speiseroehre: { opacity: 1, fill: alkoholcolor },
      magen: { opacity: 1, fill: alkoholcolor },
      duenndarm: { opacity: 1, fill: alkoholcolor },
      leber: { opacity: 1 },
      bauchspeicheldruese: { opacity: 1 },
      gallenblase: { opacity: 1 },
      dickdarm: { opacity: 1 },
      bodycontours: { stroke: bgcolor, strokeWidth: 1 },
      bodybg: { fill: bodycolor },
    },
    third: {
      gefaesse: { opacity: 0 },
      venen: { opacity: 0 },
      arterien: { opacity: 0 },
      herz: { opacity: 0 },
      hirn: { opacity: 0 },

      organs: { opacity: 1 },
      speiseroehre: { opacity: 1, fill: alkoholcolor },
      magen: { opacity: 1, fill: alkoholcolor },
      duenndarm: { opacity: 1, fill: alkoholcolor },
      leber: { opacity: 1 },
      bauchspeicheldruese: { opacity: 1 },
      gallenblase: { opacity: 1 },
      dickdarm: { opacity: 1 },
      bodycontours: { stroke: bgcolor, strokeWidth: 1 },
      bodybg: { fill: bodycolor },
    },
    fourth: {
      organs: { opacity: 0 },
      speiseroehre: { opacity: 0 },
      magen: { opacity: 0 },
      duenndarm: { opacity: 0 },
      leber: { opacity: 0 },
      bauchspeicheldruese: { opacity: 0 },
      gallenblase: { opacity: 0 },
      dickdarm: { opacity: 0 },
      gefaesse: { opacity: 1 },
      herz: { opacity: 1, fill: arteriescolor },
      venen: { opacity: 1, fill: veincolor, stroke: 'none' },
      arterien: { opacity: 1, fill: arteriescolor, stroke: 'none' },
      hirn: { opacity: 1, fill: inimportantcolor, stroke: 'none' },
    },
    fifth: {
      organs: { opacity: 1 },
      gefaesse: { opacity: 1 },
      herz: { opacity: 1, fill: alkoholcolor },
      venen: { opacity: 1, fill: alkoholcolor },
      arterien: { opacity: 1, fill: alkoholcolor },
      hirn: { opacity: 1, fill: alkoholcolor, stroke: 'none' },
    },
    sixt: {
      organs: { opacity: 1 },
      gefaesse: { opacity: 1 },
      speiseroehre: { opacity: 0 },
      magen: { opacity: 0 },
      bodycontours: { strokeWidth: 0 },
      hirn: { opacity: 1, fill: alkoholcolor, stroke: 'none' },
      venen: { opacity: 1, fill: organcolor },
      arterien: { opacity: 1, fill: organcolor },
      herz: { opacity: 1, fill: organcolor },
    },
    seventh: {
      organs: { opacity: 1 },
      lunge: { opacity: 0.35, fill: alkoholcolor, stroke: 'none' },
      luftroehre: { opacity: 0.35, fill: alkoholcolor, stroke: 'none' },
      leber: { opacity: 1, fill: alkoholcolor },
      nieren: { opacity: 0.35, fill: alkoholcolor, stroke: 'none' },
      bodycontours: { stroke: bgcolor },
      arrows: { fill: alkoholcolor, opacity: 0.25, stroke: 'none' },
    },
    eight: {
      bodybg: {
        fill: alkoholcolor,
      },
      bodycontours: { strokeWidth: 0, opacity: 0 },
      organs: { opacity: 1 },
      leber: { opacity: 1, fill: bodycolor, stroke: 'none' },
    },
    nine: {
      organs: { opacity: 1 },
      leber: { opacity: 1, fill: alkoholcolor },
      bauchspeicheldruese: {
        opacity: 1,
        fill: alkoholcolor,
      },
      magen: { opacity: 1, fill: alkoholcolor },
      dickdarm: { opacity: 1, fill: alkoholcolor },
      herz: { opacity: 1, fill: alkoholcolor },
      speiseroehre: { opacity: 1, fill: alkoholcolor },
      hirn: { opacity: 1, fill: alkoholcolor },
       baby: { opacity: 1, fill: alkoholcolor },
    },
    ten: {
      organs: { opacity: 1 },
      leber: { opacity: 1, fill: damagecolor },
      bauchspeicheldruese: {
        opacity: 1,
        fill: damagecolor,
      },
      magen: { opacity: 1, fill: damagecolor },
      dickdarm: { opacity: 1, fill: damagecolor },
      herz: { opacity: 1, fill: damagecolor },
      speiseroehre: { opacity: 1, fill: damagecolor },
      hirn: { opacity: 1, fill: damagecolor },
       baby: { opacity: 1, fill: damagecolor },
    },
  }
console.log(isMobile)


const damagestyle={

  dy:isMobile?25:20
}

  const Anotations: {
    [key: string]: {
      text: JSX.Element
      pos: { x: number; y: number }
      id?: string
    }[]
  } = {
    seventh: [
      {
        text: (
          <text style={{ fill: alkoholcolor, fontSize:isMobile?"18px":"11px"}} textAnchor='start'>
            <tspan className='b' style={{ fontSize:isMobile?"18px":"11px"}}>10%</tspan>

            <tspan x={0} dy={isMobile?18:11}>
              {TEXT.annos_1[0]}, {TEXT.annos_1[1]},
            </tspan>
            <tspan x={0} dy={isMobile?22:11}>
              {TEXT.annos_1[2]}
            </tspan>
          </text>
        ),
        pos: { x: 100, y: 40 },
      },
      {
        text: (
          <text style={{ fill: alkoholcolor , fontSize:isMobile?"18px":"11px"}} textAnchor='start'>
            <tspan className='b' style={{ fontSize:isMobile?"18px":"11px"}} >90%</tspan>
            <tspan x={0} dy={isMobile?18:11}>
              {TEXT.annos_2[0]}
            </tspan>
            <tspan x={0} dy={isMobile?18:11}>
              {TEXT.annos_2[1]}
            </tspan>
          </text>
        ),
        pos: { x: 115, y: 310 },
      },
      {
        id: 'leber',
        text: (
          <LeberDiagramm
            opacity={0}
            alcoholcolor={colorMode === 'dark' ? alkoholcolor : alkoholcolor}
            bgcolor={colorMode === 'dark' ? bodycolor : '#fff'}
            coalcolor={'#525252'}
            oxygencolor={colorMode === 'dark' ? '#cecece' : '#888'}
          />
        ),
        pos: { x: 65, y: 270 },
      },
    ],
    eight: [
      {
        id: 'leber',
        text: (
          <LeberDiagramm
            opacity={1}
            alcoholcolor={colorMode === 'dark' ? alkoholcolor : alkoholcolor}
            bgcolor={colorMode === 'dark' ? organcolor : '#fff'}
            coalcolor={colorMode === 'dark' ? '#fff' : '#888'}
            oxygencolor={colorMode === 'dark' ? '#ababab' : '#aaa'}
          />
        ),
        pos: { x: 64, y: 268 },
      },
    ],
    ten: [
      {
        id: 'leber',
        text: (
          <AnnotationWithLine
            from={{ x: isMobile ? -45 : -150, y: 0 }}
            to={{ x: isMobile ? 30 : 75, y: 20 }}
          >
            <text textAnchor='end' x={-20} >
              <tspan className='b' >{TEXT.longtime_1[0]}</tspan>
              {(TEXT.longtime_1 as string[]).slice(1).map((m) => {
                return (
                  <tspan dy={damagestyle.dy} x={-20}>
                    {m}
                  </tspan>
                )
              })}
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 55, y: 275 },
      },
      {
        id: 'mundhoehle',
        text: (
          <AnnotationWithLine
            from={{ x: isMobile ? -45 : -150, y: 0 }}
            to={{ x: isMobile ? 25 : 70, y: 20 }}
          >
            <text textAnchor='end' x={-20}>
              <tspan className='b'>{TEXT.longtime_2[0]}</tspan>
              <tspan className='b' dy={damagestyle.dy} x={-20}>
                {TEXT.longtime_2[1]}
              </tspan>
              <tspan dy={damagestyle.dy} x={-20}>
                {TEXT.longtime_2[2]}
              </tspan>
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 55, y: 85 },
      },
      {
        id: 'lunge',
        text: (
          <AnnotationWithLine
            from={{ x: isMobile ? -45 : -150, y: 0 }}
            to={{ x: isMobile ? 30 :70, y: 20 }}
          >
            <text textAnchor='end' x={-20}>
              <tspan className='b'>{TEXT.longtime_3[0]}</tspan>
              {(TEXT.longtime_3 as string[]).slice(1).map((m) => {
                return (
                  <tspan dy={damagestyle.dy} x={-20}>
                    {m}
                  </tspan>
                )
              })}
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 55, y: 685 },
      },
      {
        id: 'muskeln',
        text: (
          <AnnotationWithLine
          from={{ x: isMobile ? 70 : 150, y: 0 }}
          to={{ x: isMobile ? -32 : -58, y: 20 }}
          >
            <text textAnchor='start' x={20}>
              <tspan className='b'>{TEXT.longtime_4[0]}</tspan>
              <tspan dy={damagestyle.dy} x={20}>
                {TEXT.longtime_4[1]}
              </tspan>
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 155, y: 550 },
      },
      {
        id: 'bauchspeichel',
        text: (
          <AnnotationWithLine
            from={{ x: isMobile ? 70 : 150, y: 0 }}
            to={{ x: isMobile ? -32 : -58, y: 20 }}
          >
            <text textAnchor='start' x={20}>
              <tspan className='b'>{TEXT.longtime_5[0]}</tspan>
              {(TEXT.longtime_5 as string[]).slice(1).map((m) => {
                return (
                  <tspan dy={damagestyle.dy} x={20}>
                    {m}
                  </tspan>
                )
              })}
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 155, y: 440 },
      },

      {
        id: 'magen',
        text: (
          <AnnotationWithLine
            from={{ x: isMobile ? 70 : 150, y: 0 }}
            to={{ x: isMobile ? -25 : -70, y: 20 }}
          >
            <text textAnchor='start' x={20}>
              <tspan className='b'>{TEXT.longtime_10[0]}</tspan>
              {(TEXT.longtime_10 as string[]).slice(1).map((m) => {
                return (
                  <tspan dy={damagestyle.dy} x={20}>
                    {m}
                  </tspan>
                )
              })}
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 155, y: 320 },
      },
      {
        id: 'herz',
        text: (
          <AnnotationWithLine
            from={{ x: isMobile ? 70 : 150, y: 0 }}
            to={{ x: isMobile ? -40 : -75, y: 20 }}
          >
            <text textAnchor='start' x={20}>
              <tspan className='b'>{TEXT.longtime_8[0]}</tspan>
              {(TEXT.longtime_8 as string[]).slice(1).map((m) => {
                return (
                  <tspan dy={damagestyle.dy} x={20}>
                    {m}
                  </tspan>
                )
              })}
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 155, y: 235 },
      },
      {
        id: 'gehirn',
        text: (
          <AnnotationWithLine
            from={{ x: isMobile ? 70 : 150, y: 0 }}
            to={{ x: isMobile ? -40 : -70, y: 20 }}
          >
            <text textAnchor='start' x={20}>
              <tspan className='b'>{TEXT.longtime_9[0]}</tspan>
              {(TEXT.longtime_9 as string[]).slice(1).map((m) => {
                return (
                  <tspan dy={damagestyle.dy} x={20}>
                    {m}
                  </tspan>
                )
              })}
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 155, y: 35 },
      },
      {
        id: 'baby',
        text: (
          <AnnotationWithLine
          from={{ x: isMobile ? -45 : -150, y: 0 }}
          to={{ x: isMobile ? 50 : 90, y: 20 }}
          >
            <text textAnchor='end' x={-20}>
              <tspan className='b'>{TEXT.longtime_11[0]}</tspan>
              {(TEXT.longtime_11 as string[]).slice(1).map((m) => {
                return (
                  <tspan dy={damagestyle.dy} x={-20}>
                    {m}
                  </tspan>
                )
              })}
            </text>
          </AnnotationWithLine>
        ),
        pos: { x: 55, y: 410 },
      },
    ],
  }
  return (
    <StyledBodyComponent
      className='container'
      height={height}
      style={Layers[view].container ? Layers[view].container : {}}
    >
      <BodyWrapper height={height}>
        <BodySvg
          height={height}
          view={Views[view]}
          layers={Layers[view]}
          annotations={Anotations[view]}
          bodycolor={bodycolor}
          bgcolor={bgcolor}
          organfill={organcolor}
        />
      </BodyWrapper>
    </StyledBodyComponent>
  )
}

const AnnotationWithLine = ({
  from,
  to,
  children,
}: {
  from: { x: number; y: number }
  to: { x: number; y: number }
  children: ReactNode
}) => {
  return (
    <StyledAnnotationWithLine
      transform={`translate(${from.x},${from.y})`}
      style={{ pointerEvents: 'all' }}
    >
      <circle cx={to.x + '%'} r={3} fill=' var(--text-color)' />
      <line x1={to.x + '%'} stroke=' var(--text-color)' />
      <g transform={`translate(${0},0)`}>{children}</g>
    </StyledAnnotationWithLine>
  )
}

const StyledAnnotationWithLine = styled.g`
  tspan {
    font-size: 15px !important;
    fill: var(--text-color);
    @media only screen and (max-width: 711px) {
      font-size:22px !important;
    
    }
  }
  tspan.b {
    font-size: 18px !important;
    fill: #d3343f;
    @media only screen and (max-width: 711px) {
      font-size:25px !important;
    
    }
  }
`

const BodyWrapper = styled.div<{ height: number }>`
  display: inline-block;
  width: 100%;
  height: ${({ height }) => height + 'px'};
  max-height: 100%;
  overflow: hidden;
  position: relative;
`
const StyledBodyComponent = styled.div<{ height: number }>`
  display: inline-block;
  width: 100%;
  height: ${({ height }) => height + 'px'};
  transition: all 1s ease;
  max-height: 100%;
`
